<template>
  <div>
    <!-- <portal-target name="modal"></portal-target> -->
    <div class="flex h-screen overflow-hidden bg-white">
      <div class="lg:hidden">
        <div @click="sidebarOpen = !sidebarOpen" v-show="sidebarOpen" class="fixed inset-0 z-40 flex">
          <transition enter-active-class="transition-opacity duration-300 ease-linear" enter-class="opacity-0"
            enter-to-class="opacity-100" leave-active-class="transition-opacity duration-300 ease-linear"
            leave-class="opacity-100" leave-to-class="opacity-0">
            <div class="fixed inset-0">
              <div @click="sidebarOpen = !sidebarOpen" class="absolute inset-0 bg-gray-600 opacity-75"></div>
            </div>
          </transition>
          <transition enter-active-class="transition duration-300 ease-in-out transform" enter-class="-translate-x-full"
            enter-to-class="translate-x-0" leave-active-class="transition duration-300 ease-in-out transform"
            leave-class="translate-x-0" leave-to-class="-translate-x-full">
            <div class="relative flex flex-col flex-1 w-full max-w-xs pt-5 pb-4 bg-white">
              <div class="absolute top-0 right-0 p-1 -mr-14">
                <button
                  class="flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-gray-600"
                  aria-label="Close sidebar">
                  <svg class="w-6 h-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div class="flex items-center flex-shrink-0 px-4">
                <img class="w-auto h-8" src="/img/logo.svg" alt="Logo A bit safer today">
              </div>
              <div v-if="is('BCSA')" class="flex-1 h-0 mt-5 overflow-y-auto">
                <nav class="px-2">
                  <div class="space-y-1">
                    <inertia-link v-for="item in menu" :key="item.name" :href="item.link"
                      :class="{ 'bg-gray-50': isActive(item.link) }"
                      class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                      <svg v-show="item.name == 'Dashboard'"
                        class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                      </svg>

                      <svg v-show="item.name == 'Campagnes'"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                      </svg>

                      <svg v-show="item.name == 'Organisaties'"
                        class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                      </svg>
                      <svg v-show="item.name == 'Geplande pogingen'"
                        class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <svg v-show="item.name == 'Verstuurde pogingen'"
                        class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76">
                        </path>
                      </svg>
                      <svg v-show="item.name == 'Templates'"
                        class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z">
                        </path>
                      </svg>
                      {{ item.name }}
                    </inertia-link>
                  </div>
                  <div class="mt-8">
                    <h3 class="px-3 text-xs font-semibold leading-4 tracking-wider text-gray-500 uppercase"
                      id="campaigns-headline">
                      Campagnes
                    </h3>
                    <div class="mt-1 space-y-1" role="group" aria-labelledby="campaigns-headline">

                      <a href="#" v-for="campaign in $page.props.campaigns_recent.data" :key="campaign.id"
                        class="flex items-center px-3 py-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                        <span class="w-2.5 h-2.5 mr-4 bg-green-500 rounded-full"></span>
                        <span class="truncate">
                          {{ campaign.name }}
                        </span>
                      </a>

                    </div>
                  </div>
                </nav>
              </div>


              <div v-if="is('Customer')" class="flex-1 h-0 mt-5 overflow-y-auto">
                <nav class="px-2">
                  <div class="space-y-1">
                    <inertia-link v-for="item in menuCustomer" :key="item.name" :href="item.link"
                      :class="{ 'bg-gray-50': isActive(item.link) }"
                      class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                      <svg v-show="item.name == 'Dashboard'"
                        class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                      </svg>

                      <svg v-show="item.name == 'Organisatie'"
                        class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                      </svg>

                      <svg v-show="item.name == 'Campagnes'"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                      </svg>
                      {{ item.name }}
                    </inertia-link>
                  </div>
                  <div class="mt-8">
                    <h3 class="px-3 text-xs font-semibold leading-4 tracking-wider text-gray-500 uppercase"
                      id="campaigns-headline">
                      Campagnes
                    </h3>
                    <div class="mt-1 space-y-1" role="group" aria-labelledby="campaigns-headline">

                      <a href="#" v-for="campaign in $page.props.campaigns_recent_customer.data" :key="campaign.id"
                        class="flex items-center px-3 py-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                        <span class="w-2.5 h-2.5 mr-4 bg-green-500 rounded-full"></span>
                        <span class="truncate">
                          {{ campaign.name }}
                        </span>
                      </a>

                    </div>
                  </div>
                </nav>
              </div>


            </div>
          </transition>
          <div class="flex-shrink-0 w-14">
            <!-- Dummy element to force sidebar to shrink to fit close icon -->
          </div>
        </div>
      </div>
      <!-- Static sidebar for desktop -->
      <div class="hidden lg:flex lg:flex-shrink-0">
        <div class="flex flex-col w-64 pt-5 pb-4 bg-gray-100 border-r border-gray-200">
          <div class="flex items-center flex-shrink-0 px-6">
            <img class="w-auto h-8" src="/img/logo.svg" alt="Logo A bit safer today">
          </div>
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <div class="flex flex-col flex-1 h-0 overflow-y-auto">
            <!-- User account dropdown -->
            <div class="relative inline-block px-3 mt-6 text-left">
              <!-- Dropdown menu toggle, controlling the show/hide state of dropdown menu. -->
              <div @click="userDropDown = !userDropDown">
                <button type="button"
                  class="group w-full rounded-md px-3.5 py-2 text-sm leading-5 font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-500 focus:outline-none focus:bg-gray-200 focus:border-blue-300 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                  id="options-menu" aria-haspopup="true" aria-expanded="true">
                  <div class="flex items-center justify-between w-full">
                    <div class="flex items-center justify-between min-w-0 space-x-3">
                      <img class="flex-shrink-0 w-10 h-10 bg-gray-300 rounded-full" src="/img/avataaars.svg" alt="">
                      <div class="flex-1 min-w-0 text-left">
                        <h2 class="text-sm font-medium leading-5 text-gray-900 truncate">{{ $page.props.auth.user.name
                        }}</h2>
                        <!-- <p class="text-xs leading-5 text-gray-500 truncate">Reseller</p> -->
                      </div>
                    </div>
                    <!-- Heroicon name: selector -->
                    <svg class="flex-shrink-0 w-5 h-5 text-gray-400 group-hover:text-gray-500"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd"
                        d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                  </div>
                </button>
              </div>
              <transition enter-active-class="transition duration-100 ease-out"
                enter-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                leave-active-class="transition duration-75 ease-in" leave-class="transform scale-100 opacity-100"
                leave-to-class="transform scale-95 opacity-0">
                <div v-show="userDropDown"
                  class="absolute left-0 right-0 z-10 mx-3 mt-1 origin-top rounded-md shadow-lg">
                  <div class="bg-white rounded-md shadow-xs" role="menu" aria-orientation="vertical"
                    aria-labelledby="options-menu">
                    <!-- <div class="py-1">
                    <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">View profile</a>
                    <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Settings</a>
                    <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Notifications</a>
                  </div>
                  <div class="border-t border-gray-100"></div>
                  <div class="py-1">
                    <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Get desktop app</a>
                    <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Support</a>
                  </div> -->
                    <div class="border-t border-gray-100"></div>
                    <div class="py-1">
                      <inertia-link href="/logout"
                        class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                        role="menuitem">Uitloggen</inertia-link>
                    </div>
                    <div class="py-1">
                      <inertia-link href="/user"
                        class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                        role="menuitem">Profiel</inertia-link>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- Sidebar Search -->
            <div class="px-3 mt-5">
              <div class="relative mt-1 rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <!-- Heroicon name: mail -->
                  <svg class="w-4 h-4 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd" />
                  </svg>
                </div>
                <input type="text" id="search"
                  class="block w-full pl-10 border-gray-300 rounded-md focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                  placeholder="Zoeken">
              </div>
            </div>
            <!-- Navigation -->




            <nav v-if="is('BCSA')" class="px-3 mt-6">
              <div class="space-y-1">
                <inertia-link v-for="item in menu" :key="item.name" :href="item.link"
                  :class="{ 'bg-gray-50': isActive(item.link) }"
                  class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                  <svg v-show="item.name == 'Dashboard'"
                    class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  <svg v-show="item.name == 'Campagnes'"
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                  </svg>
                  <svg v-show="item.name == 'Organisaties'"
                    class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                  </svg>
                  <svg v-show="item.name == 'Geplande pogingen'"
                    class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <svg v-show="item.name == 'Verstuurde pogingen'"
                    class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76">
                    </path>
                  </svg>
                  <svg v-show="item.name == 'Templates'"
                    class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z">
                    </path>
                  </svg>
                  {{ item.name }}
                </inertia-link>
              </div>
              <div class="mt-8">
                <!-- Secondary navigation -->
                <h3 class="px-3 text-xs font-semibold leading-4 tracking-wider text-gray-500 uppercase"
                  id="campaigns-headline">
                  Lopende campagnes
                </h3>
                <div class="mt-1 space-y-1" role="group" aria-labelledby="campaigns-headline">

                  <inertia-link :href="'/campaign/' + campaign.id" v-for="campaign in $page.props.campaigns_recent.data"
                    :key="campaign.id"
                    class="flex items-center px-3 py-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                    <span class="w-2.5 h-2.5 mr-4 bg-green-500 rounded-full"></span>
                    <span class="truncate">
                      {{ campaign.name }}
                    </span>
                  </inertia-link>

                </div>
              </div>
            </nav>


            <nav v-if="is('Customer')" class="px-3 mt-6">
              <div class="space-y-1">
                <inertia-link v-for="item in menuCustomer" :key="item.name" :href="item.link"
                  :class="{ 'bg-gray-50': isActive(item.link) }"
                  class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                  <svg v-show="item.name == 'Dashboard'"
                    class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  <svg v-show="item.name == 'Organisatie'"
                    class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                  </svg>
                  <svg v-show="item.name == 'Campagnes'"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-3 text-gray-500 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                      </svg>
                  {{ item.name }}
                </inertia-link>
              </div>
              <div class="mt-8">
                <!-- Secondary navigation -->
                <h3 class="px-3 text-xs font-semibold leading-4 tracking-wider text-gray-500 uppercase"
                  id="campaigns-headline">
                  Lopende campagnes
                </h3>
                <div class="mt-1 space-y-1" role="group" aria-labelledby="campaigns-headline">

                  <inertia-link :href="'/campaign/' + campaign.id" v-for="campaign in $page.props.campaigns_recent_customer.data"
                    :key="campaign.id"
                    class="flex items-center px-3 py-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                    <span class="w-2.5 h-2.5 mr-4 bg-green-500 rounded-full"></span>
                    <span class="truncate">
                      {{ campaign.name }}
                    </span>
                  </inertia-link>

                </div>
              </div>
            </nav>









          </div>
        </div>
      </div>
      <!-- Main column -->
      <div class="flex flex-col flex-1 w-0 overflow-hidden">
        <!-- Zoeken header -->
        <div class="relative z-10 flex flex-shrink-0 h-16 bg-white border-b border-gray-200 lg:hidden">
          <!-- Sidebar toggle, controls the 'sidebarOpen' sidebar state. -->
          <button @click="sidebarOpen = !sidebarOpen"
            class="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:bg-gray-100 focus:text-gray-600 lg:hidden"
            aria-label="Open sidebar">
            <svg class="w-6 h-6" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              viewBox="0 0 24 24" stroke="currentColor">
              <path d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </button>
          <div class="flex justify-between flex-1 px-4 sm:px-6 lg:px-8">
            <!-- <div class="flex flex-1">
              <form class="flex w-full md:ml-0" action="#" method="GET">
                <label for="search_field" class="sr-only">Zoeken</label>
                <div class="relative w-full text-gray-400 focus-within:text-gray-600">
                  <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" />
                    </svg>
                  </div>
                  <input id="search_field"
                    class="block w-full h-full py-2 pl-8 pr-3 text-gray-900 placeholder-gray-500 rounded-md focus:outline-none focus:placeholder-gray-400 sm:text-sm"
                    placeholder="Zoeken" type="search">
                </div>
              </form>
            </div> -->
            <div class="flex items-center">
              <!-- Profile dropdown -->
              <div class="relative inline-block px-2 mt-2 text-left">
                <!-- Dropdown menu toggle, controlling the show/hide state of dropdown menu. -->
                <div @click="userDropDown = !userDropDown">
                  <button type="button"
                    class="group w-full rounded-md px-3.5 py-2 text-sm leading-5 font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-500 focus:outline-none focus:bg-gray-200 focus:border-blue-300 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                    id="options-menu" aria-haspopup="true" aria-expanded="true">
                    <div class="flex items-center justify-between w-full">
                      <div class="flex items-center justify-between min-w-0 space-x-3">
                        <img class="flex-shrink-0 w-10 h-10 bg-gray-300 rounded-full" src="/img/avataaars.svg" alt="">
                        <div class="flex-1 min-w-0 text-left">
                          <h2 class="text-sm font-medium leading-5 text-gray-900 truncate">{{ $page.props.auth.user.name
                          }}</h2>
                          <!-- <p class="text-xs leading-5 text-gray-500 truncate">Reseller</p> -->
                        </div>
                      </div>
                      <!-- Heroicon name: selector -->
                      <svg class="flex-shrink-0 w-5 h-5 text-gray-400 group-hover:text-gray-500"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                          d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                          clip-rule="evenodd" />
                      </svg>
                    </div>
                  </button>
                </div>
                <transition enter-active-class="transition duration-100 ease-out"
                  enter-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                  leave-active-class="transition duration-75 ease-in" leave-class="transform scale-100 opacity-100"
                  leave-to-class="transform scale-95 opacity-0">
                  <div v-show="userDropDown"
                    class="absolute left-0 right-0 z-10 mx-3 mt-1 origin-top rounded-md shadow-lg">
                    <div class="bg-white rounded-md shadow-xs" role="menu" aria-orientation="vertical"
                      aria-labelledby="options-menu">
                      <div class="border-t border-gray-100"></div>
                      <div class="py-1">
                        <inertia-link href="/logout"
                          class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                          role="menuitem">Uitloggen</inertia-link>
                      </div>
                      <div class="py-1">
                      <inertia-link href="/user"
                        class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                        role="menuitem">Profiel</inertia-link>
                    </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <main class="relative z-0 flex-1 h-full overflow-y-auto focus:outline-none" tabindex="0">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    default: "A bit safer today"
  },
  data: () => ({
    menu: [
      { "name": 'Dashboard', "link": '/' },
      { "name": 'Campagnes', "link": '/campaigns' },
      { "name": 'Organisaties', "link": '/organisations' },
      { "name": 'Geplande pogingen', "link": '/schedule' },
      { "name": 'Verstuurde pogingen', "link": '/attempts' },
      { "name": 'Templates', "link": '/templates' },
    ],
    menuCustomer: [
      { "name": 'Dashboard', "link": '/' },
      { "name": 'Organisatie', "link": '/organisation' },
      { "name": 'Campagnes', "link": '/campaigns' },
    ],
    sidebarOpen: false,
    userDropDown: false,
    userDropDownMobile: false,
  }),
  watch: {
    title: {
      immediate: true,
      handler(title) {
        document.title = title
      },
    },
  },
  methods: {
    isActive(link) {
      return link == window.location.pathname;
    }
  }
}
</script>
